import React, { useEffect, useState } from 'react';
import Icon from './Icon';

interface TimerProps {
  duration: number;
  onTimeout: () => void;
  paused: boolean;
}

export default function Timer({ duration, onTimeout, paused }: TimerProps) {
  const [remaining, setRemaining] = useState(duration);

  useEffect(() => {
    if (paused || remaining <= 0) return;
    const id = setTimeout(() => setRemaining(r => r - 1), 1000);
    return () => clearTimeout(id);
  }, [paused, remaining]);

  useEffect(() => {
    if (remaining === 0) onTimeout();
  }, [remaining, onTimeout]);

  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;
  const tone = remaining < 30 ? 'critical' : remaining < 60 ? 'urgent' : '';

  return (
    <div className={`timer ${tone} ${paused ? 'paused' : ''}`} role="timer" aria-label="Time remaining">
      <Icon name="clock" size={14} />
      {mins}:{secs.toString().padStart(2, '0')}
    </div>
  );
}
